/**
 * @file contains helper functions for the AttachmentList component
 */

import { AttachmentMode } from '../../../models/attachment';

/**
 * Check if empty illustration should be shown
 *
 * @param mode              Attachment mode
 * @param attachmentsLength Length of attachments array
 * @returns                 Whether to show empty illustration
 */
export const getShouldShowEmptyIllustration = (
  mode: AttachmentMode,
  attachmentsLength: number,
): boolean => {
  return mode === 'detailsEdit' && attachmentsLength === 0;
};
